// src/API/Address/ViewAddedAddressByIdAsync.ts

import { toast } from "react-toastify";
import { Address } from "./ViewAllAddedAddressByUserAsync"; // Or define/re-export Address here if needed
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

/**
 * @param addressId - The ID of the address to fetch.
 * @param token - The authentication token.
 * @returns A promise that resolves to an array of Address objects.
 */
export async function viewAddedAddressByIdAsync(
  addressId: string,
  token: string,
  t: (key: string) => string
): Promise<Address[] | null> {

  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }

  if (!navigator.onLine) {
    toast.error("You are offline. Please check your internet connection.");
    return Promise.reject(new Error("User is offline"));
  }
  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(
      `${baseUrl}/api/Address/ViewAddedAddressByIdAsync?addressId=${addressId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
    );

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`${errorData.message}`);
      }

    const data: Address[] = await response.json();
    return data;
  } catch (error) {
    // console.error("Error fetching address details:", error);
    throw error;
  }
}
function t(arg0: string): import("react-toastify").ToastContent<unknown> {
  throw new Error("Function not implemented.");
}

